import template from 'text!./confirmationBackButton.html';

export default {
    template: template,
    binds: {
        ngClick: '&'
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/common/components/confirmationBackButton/index.js
// module id = 1511
// module chunks = 0